module.exports = __webpack_public_path__ + "img/config.db14d9c3.svg";